<template>
  <div class="report-details-card">
    <div class="title-wrapper">
      <img src="@/assets/images/title_decoration_left.png" alt="装饰left">
      <div class="report-name">{{title}}</div>
      <img src="@/assets/images/title_decoration_right.png" alt="装饰right">
    </div>
    <div class="report-content" v-html="content" />
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    },
    content: {
      type: String,
      required: true
    }
  }
}

</script>

<style scoped lang="scss">
.title-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 20px;
  img {
    height: 10px;
  }
  .report-name {
    padding: 0 6px;
    font-size: 18px;
    font-weight: 600;
    line-height: 23.87px;
    color: rgba(18, 18, 18, 1);
    text-align: center;
  }
}
.report-content {
  padding: 0 20px;
  box-sizing: border-box;
  font-size: 12px;
  font-weight: 500;
  line-height: 23px;
  color: rgba(59, 59, 59, 1);
  text-align: left;
}
</style>